var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.item.created_at))]),_c('td',[_vm._v(_vm._s(_vm.item.trust_balance))]),_c('td',[_vm._v(_vm._s(_vm.item.balance))]),_c('td',[_vm._v(_vm._s(_vm.item.difference))]),_c('td',[_c('div',{class:`status status-color-${_vm.item.status}`}),_vm._v(_vm._s(_vm.getStatus(_vm.item.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }